//# sourceMappingURL=organization_setup.mjs.map
/// <reference types="./organization_setup.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $organization_setup from "../../admin/effects/organization_setup.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok } from "../../gleam.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiStartedLoadingQualificationMatrix) {
    let org_id = msg.org_id;
    let _pipe = new $remote.Loading();
    let _pipe$1 = ((_capture) => {
      return $dict.insert(store.organizations_qm_rows, org_id, _capture);
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $store.set_organizations_qm_rows(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedQualificationMatrix) {
    let org_id = msg.org_id;
    let qm_rows = msg.qm_rows;
    let rows = new $remote.Loaded(qm_rows);
    let rows$1 = $dict.insert(store.organizations_qm_rows, org_id, rows);
    let _pipe = store;
    let _pipe$1 = $store.set_organizations_qm_rows(_pipe, rows$1);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.ApiSavedDefaults) {
    let org_id = msg.org_id;
    let ai_config = msg.ai_config;
    let tags = msg.tags;
    let qm_rows = msg.qm_rows;
    let tags$1 = new $remote.Loaded(tags);
    let rows = new $remote.Loaded(qm_rows);
    let tags$2 = $dict.insert(store.organizations_tags, org_id, tags$1);
    let rows$1 = $dict.insert(store.organizations_qm_rows, org_id, rows);
    let _pipe = store;
    let _pipe$1 = $store.set_ai_config(_pipe, ai_config);
    let _pipe$2 = $store.set_organizations_qm_rows(_pipe$1, rows$1);
    let _pipe$3 = $store.set_organizations_tags(_pipe$2, tags$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.UserClickedSetup) {
    return [store, $organization_setup.set_defaults()];
  } else {
    let org_id = msg.org_id;
    let tag = msg.tag;
    let $ = $dict.get(store.organizations_tags, org_id);
    if ($ instanceof Ok) {
      let $1 = $[0];
      if ($1 instanceof $remote.NotLoaded) {
        return [store, $effect.none()];
      } else if ($1 instanceof $remote.Loading) {
        return [store, $effect.none()];
      } else if ($1 instanceof $remote.Errored) {
        return [store, $effect.none()];
      } else {
        let tags = $1[0];
        let _pipe = $list.filter(tags, (t) => { return t.name !== tag; });
        let _pipe$1 = new $remote.Loaded(_pipe);
        let _pipe$2 = ((_capture) => {
          return $dict.insert(store.organizations_tags, org_id, _capture);
        })(_pipe$1);
        let _pipe$3 = ((_capture) => {
          return $store.set_organizations_tags(store, _capture);
        })(_pipe$2);
        return $pair.new$(_pipe$3, $effect.none());
      }
    } else {
      return [store, $effect.none()];
    }
  }
}
